








import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'

interface Data {
  isOpen: boolean
}

interface Methods {
  close: () => void
}

interface Computed {}

interface Props {
  closeOnVoidClick: boolean
}

export default Vue.extend({
  name: 'UiModal',
  props: {
    closeOnVoidClick: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  watch: {
    isOpen: {
      handler (status) {
        if (status) {
          document.body.style.overflow = 'hidden'
          this.$nextTick(() => {
            (this.$el as any).focus()
          })
        } else {
          document.body.style.overflow = 'auto'
        }
      }
    }
  },
  methods: {
    closeClickOnVoid () {
      if (this.closeOnVoidClick) this.close()
    },
    close () {
      this.isOpen = false
      this.$emit('close')
    },
    open () {
      this.isOpen = true
      this.$emit('open')
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
